import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useDataType } from "../../hooks/use-data-type";
import { useValueRange } from "../../hooks/use-value-range";
import { useColor } from "../../hooks/use-color";


const LegendItem = ({ color, value }: { color: string, value: string }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box
        sx={{
          width: 20,
          height: 22,
          float: 'left',
          marginRight: 1,
          backgroundColor: color,
        }}
      />
      <Typography variant='body2'>{value}</Typography>
    </Box>
  );
}

export const LegendPanel = () => {
  const [_, getDataTypeString] = useDataType();
  const [dataMin, dataMax] = useValueRange();
  const [getColorByValue] = useColor();

  const values = useMemo(() => {
    const steps = 9;
    const stepValue = (dataMax - dataMin) / (steps - 1);
    const res = new Array<{ color: string; value: string }>(steps);
    for (let curr = dataMin, step = 0; step < steps; step++, curr += stepValue) {
      res[step] = {
        color: getColorByValue(curr),
        value: getDataTypeString(curr)
      };
    }
    res[0].value = '< ' + res[0].value;
    res[res.length - 1].value = '> ' + res[res.length - 1].value;
    return res;
  }, [getColorByValue, dataMin, dataMax]);

  return (
    <div className={'leaflet-bottom leaflet-right'}>
      <div className='leaflet-control'>
        <Box sx={[
          (theme) => ({
            backgroundColor: theme.palette.background.default,
          }),
          {
            padding: 1,
            marginBottom: 2,
            boxShadow: '0 0 15px rgba(0, 0, 0, 0.2)',
            borderRadius: 1,
            opacity: 1.0,
          }]}
        >
          {values && (
            values.map((v, i) => <LegendItem key={i} value={v.value} color={v.color} />))
          }
        </Box>
      </div>
    </div>
  )
};
